import {AfterViewInit, Component, Input} from '@angular/core';
import {GaugeCircleChartData} from '../../../../../models/influencer';
import {CircleChartData} from '../../../../../models/chart';
import {Platform} from '../../../../../models/platform';
import {platformIconPath} from '../../../../app.constants';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../../services/user.service';
import {ReferenceDataService} from '../../../../services/reference-data/reference-data.service';

@Component({
  selector: 'platform-reache',
  templateUrl: './platform-reache.component.html',
  styleUrls: ['./platform-reache.component.scss']
})
export class PlatformReacheComponent implements AfterViewInit {
  static COMPONENT_NAME = 'PlatformReacheComponent';

  @Input() activePlatforms: number[];
  @Input() platforms: GaugeCircleChartData[] = [];
  @Input() forPayingUser = false;


  constructor(private pdfService: PdfExportService,
              private referenceData: ReferenceDataService,
              private userService: UserService) {
  }
  get showFallbackView() {
    return this.platforms.length === 0 || (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin);
  }

  get platformList() {
    if (!Array.isArray(this.activePlatforms) || this.activePlatforms.length === 0) {
      return [];
    }
    const activePlatformNames = this.referenceData.platforms.filter(p => this.activePlatforms.indexOf(p.id) >= 0)
      .map(plr => plr.name.toLowerCase());
    return this.platforms.filter(p => activePlatformNames.indexOf(p.name.toLowerCase()) >= 0);
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(PlatformReacheComponent.COMPONENT_NAME);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/platform-reache/platform-reache.component.ts